import React from 'react'
import { Button as MuiButton, withStyles } from "@material-ui/core";
import { red, orange, green } from '@material-ui/core/colors';
import clsx from 'clsx';

const ColorButton = withStyles((theme) => ({
    '& .import-from-excel-table.error': {
        backgroundColor: red[100],
        color: red[600],
    },
    warning: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: orange[500],
        '&:hover': {
            backgroundColor: orange[700],
        },
    },
    success: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    danger: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700],
        },
    },
}))(MuiButton);
export default function ButtonColor(props) {

    const { text, size, color, variant, onClick, status, ...other } = props

    return (
        <ColorButton
            variant={variant || "contained"}
            size={size || "large"}
            color={color || "primary"}
            onClick={onClick}
            {...other}
            className={clsx('root', 'label', { success: status === 'success', danger: status === 'danger', warning: status === 'warning' })}
            //className={`${classes.root} ${classes.label} ${classes[color]}`}
            //classes={{ root: classes.root, label: classes.label, classes[status] }}
        >
            {text}
        </ColorButton>
    )
}
